{
  "similar": {
    "title": "類似オークション"
  },
  "related": {
    "set": "同じセットのカード",
    "character": "同じキャラクターのカード",
    "grade": "同じグレード",
    "price": "近い価格帯"
  },
  "forYou": {
    "title": "あなたへのおすすめ"
  },
  "trending": {
    "title": "トレンドカード",
    "noPrice": "—",
    "sales": "直近{count}件の取引"
  },
  "recentlyViewed": {
    "title": "最近見た商品",
    "clear": "クリア"
  },
  "popularSellers": {
    "title": "人気セラー",
    "fallbackName": "BidNovaセラー",
    "new": "新規",
    "sales": "{count}件の販売実績"
  }
}
